const baseRowStyle =
  'h-[48px] border-t border-solid border-3b-background-200 bg-white';
const baseTableHeaderStyle =
  'md:px-4 px-2 flex items-center text-left whitespace-nowrap bg-3b-background-medium';
const baseTableDataStyle =
  'md:px-4 px-2 flex items-center text-left overflow-hidden min-w-0';

export { baseRowStyle, baseTableDataStyle, baseTableHeaderStyle };
